export function importData(data) {
    return axios.post(route('api.manage.companies.import'), data)
        .then(response => response.data);
}
